module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./ur.coffee"));
	}, "locale/ur");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/ur.coffee
// module id = 305
// module chunks = 100